import type { AxiosInstance } from "axios";
import { createAuthenticatedAxios } from "./axios";
import { getConfig } from "../config/environment";

/**
 * remi-api REST base for the current environment. The Spanner-backed remi-api
 * serves both GraphQL (reads) and REST (mutations + the IDX endpoints) from a
 * single Cloud Run service, so the REST base is the GraphQL URL with `/graphql`
 * swapped for `/api/v1`. Mirrors speculo-app's remi-api client so every IDX
 * call is issued the same way.
 */
export const getRemiApiBaseUrl = (): string =>
  getConfig().cloudRunServices.graphqlUrl.replace(/\/graphql\/?$/, "") + "/api/v1";

/**
 * Authenticated axios instance for remi-api REST. The Firebase ID token is
 * attached as a Bearer header when a user is signed in (see `addAuthInterceptor`);
 * the public IDX reads (team members, contact auto-fill) work unauthenticated too.
 */
export const remiApi: AxiosInstance = createAuthenticatedAxios(getRemiApiBaseUrl());
